import React, { useState } from 'react';
import './FAQSection.css';

const FAQSection = ({ id, ...props }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "Как происходит оплата и получение доступа?",
      answer: "Оплатить можно через Telegram-бот @redbutton_vpn_bot или в личном кабинете на сайте my.1button.red. Принимаем банковские карты. После оплаты бот автоматически отправляет персональную ссылку-подписку — вы добавляете её в приложение (Happ или Hiddify), и VPN готов к использованию. Весь процесс занимает меньше минуты. В боте также доступна бесплатная пробная версия."
    },
    {
      question: "Какой протокол вы используете и почему он такой стабильный?",
      answer: "Мы используем протокол VLESS на базе платформы Xray-core с обфускацией трафика. Всё соединение маскируется под обычный HTTPS на 443 порту — выглядит как обычный веб-серфинг. Это обеспечивает высокую стабильность даже в сетях с жёсткими ограничениями."
    },
    {
      question: "Какая скорость соединения и можно ли смотреть 4K видео?",
      answer: "Пропускная способность наших серверов достигает 10 Гбит/с. Этого более чем достаточно для просмотра 4K фильмов без задержек, онлайн-игр и любых других задач, требующих высокую скорость интернета."
    },
    {
      question: "С какими сервисами работает RED BUTTON?",
      answer: "Абсолютно со всеми! Netflix, Disney+, YouTube Premium, Amazon Prime, социальные сети, мессенджеры, игровые платформы, стриминговые сервисы — всё работает стабильно. Наши IP-адреса постоянно обновляются для стабильного доступа."
    },
    {
      question: "На скольких устройствах можно использовать одновременно?",
      answer: "Одна подписка позволяет подключить до 3 устройств одновременно. Установить приложение можно на любое количество устройств, но активных подключений может быть максимум 3 в один момент времени. Если все устройства подключены к одному Wi-Fi, то в качестве одного подключения считается роутер."
    },
    {
      question: "Как настроить VPN после оплаты?",
      answer: "Очень просто! После оплаты вы получаете subscription-ссылку в Telegram-боте. Скачиваете любое VPN-приложение (V2Ray, Hiddify, V2RayNG и другие), вставляете эту ссылку, и автоматически подтягиваются все доступные серверы. Готово к использованию!"
    },
    {
      question: "Какие приложения поддерживаются?",
      answer: "Поддерживаются все популярные VPN-клиенты: Happ, V2Ray, Hiddify, V2RayNG, ShadowRocket, Clash и многие другие. Доступны на всех платформах: Windows, macOS, iOS, Android, Linux. Также можно настроить на роутере для защиты всей домашней сети."
    },
    {
      question: "Безопасно ли использовать для банковских операций?",
      answer: "Абсолютно безопасно! Мы используем военное шифрование AES-256, не ведем логи активности и физически не можем передать ваши данные. Банковские операции через наш VPN даже безопаснее, чем через обычное соединение, особенно в публичных Wi-Fi."
    },
    {
      question: "Что такое подписка?",
      answer: "1. Подписка — это специальная ссылка (вы открыли её сейчас в браузере), по которой приложение получает с сервера все необходимые данные для подключения. Эта ссылка также является вашим личным кабинетом. 🔒 Не передавайте её третьим лицам — это ваш персональный ключ доступа."
    }
  ];

  return (
    <section className="faq-section" id={id} {...props}>
      <div className="faq-container">
        <div className="faq-header">
          <h2 className="faq-title">Частые вопросы</h2>
          <p className="faq-subtitle">
            Все что нужно знать о RED BUTTON VPN
          </p>
        </div>
        
        <div className="faq-list">
          {faqData.map((item, index) => (
            <div 
              key={index}
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            >
              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={activeIndex === index}
              >
                <span className="question-text">{item.question}</span>
                <span className="faq-icon">
                  {activeIndex === index ? '−' : '+'}
                </span>
              </button>
              
              <div className="faq-answer">
                <div className="answer-content">
                  <p>{item.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;